/**
 * Dictionary mapping for BODACC publication fields
 * Maps database field names to human-readable labels
 */
export const BODACC_DICTIONARY = {
  // BodaccSiren fields
  bodacc_id: 'ID BODACC',
  siren: 'SIREN',
  publicationavis: 'Type de publication',
  dateparution: 'Date de parution',
  
  // BodaccPublication fields
  id: 'ID',
  parution: 'Numéro de parution',
  numeroannonce: "Numéro d'annonce",
  typeavis: "Type d'avis",
  typeavis_lib: "Libellé du type d'avis",
  familleavis: "Famille d'avis",
  familleavis_lib: "Libellé de la famille d'avis",
  numerodepartement: 'Numéro de département',
  departement_nom_officiel: 'Nom officiel du département',
  region_code: 'Code de région',
  region_nom_officiel: 'Nom officiel de la région',
  tribunal: 'Tribunal',
  commercant: 'Commerçant',
  ville: 'Ville',
  registre: 'Registre',
  cp: 'Code postal',
  pdf_parution_subfolder: 'Sous-dossier PDF de parution',
  ispdf_unitaire: 'PDF unitaire',
  listepersonnes: 'Liste des personnes',
  listeetablissements: 'Liste des établissements',
  jugement: 'Jugement',
  acte: 'Acte',
  modificationsgenerales: 'Modifications générales',
  radiationaurcs: 'Radiation au RCS',
  depot: 'Dépôt',
  listeprecedentexploitant: 'Liste des précédents exploitants',
  listeprecedentproprietaire: 'Liste des précédents propriétaires',
  divers: 'Divers',
  parutionavisprecedent: "Parution de l'avis précédent",
  url_complete: 'URL complète',
  
  // Company info fields
  denominationUniteLegale: 'Dénomination de l\'Unité Légale',
  nomUniteLegale: 'Nom du dirigeant de l\'Unité Légale',
  prenomUsuelUniteLegale: 'Prénom du dirigeant de l\'Unité Légale',
  sexeUniteLegale: 'Sexe du dirigeant de l\'Unité Légale',
  
  // Unité Légale fields
  statutDiffusionUniteLegale: 'Statut de diffusion de l\'unité légale',
  dateCreationUniteLegale: 'Date de création de l\'unité légale',
  trancheEffectifsUniteLegale: 'Tranche d\'effectifs de l\'unité légale',
  anneeEffectifsUniteLegale: 'Année des effectifs de l\'unité légale',
  dateDernierTraitementUniteLegale: 'Date du dernier traitement de l\'unité légale',
  nombrePeriodesUniteLegale: 'Nombre de périodes de l\'unité légale',
  categorieEntreprise: 'Catégorie d\'entreprise',
  anneeCategorieEntreprise: 'Année de la catégorie d\'entreprise',
  dateDebut: 'Date de début',
  etatAdministratifUniteLegale: 'État administratif de l\'unité légale',
  denominationUsuelle1UniteLegale: 'Dénomination usuelle de l\'unité légale',
  categorieJuridiqueUniteLegale: 'Catégorie juridique de l\'unité légale',
  activitePrincipaleUniteLegale: 'Activité principale de l\'unité légale',
  nomenclatureActivitePrincipaleUniteLegale: 'Nomenclature de l\'activité principale',
  nicSiegeUniteLegale: 'NIC du siège de l\'unité légale',
  economieSocialeSolidaireUniteLegale: 'Économie sociale et solidaire de l\'unité légale',
};

/**
 * Get a human-readable label for a BODACC field
 * @param key The database field name
 * @returns The human-readable label or the original key if not found
 */
export const getBodaccFieldLabel = (key: string): string => {
  return BODACC_DICTIONARY[key as keyof typeof BODACC_DICTIONARY] || key;
}; 